var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var STORAGE_KEY = 'datastore_session_store_v14';
export function sessionStorageSyncFactory(performanceTracking) {
    var firstState = true;
    var pendingWrite = false;
    return function (reducer) { return function (state, action) {
        var nextState = state;
        if (firstState) {
            try {
                performanceTracking.mark('read-session-storage-start');
                var sessionStorageState = JSON.parse(window.sessionStorage.getItem(STORAGE_KEY) || '{}');
                performanceTracking.mark('read-session-storage-end');
                performanceTracking.measure('read-session-storage', 'read-session-storage-start', 'read-session-storage-end');
                nextState = __assign({}, state, sessionStorageState);
            }
            catch (e) {
                // ignore the errors, e.g. quota is full or security error
                console.error(e);
            }
        }
        firstState = false;
        var next = reducer(nextState, action);
        if (!pendingWrite) {
            pendingWrite = true;
            window.requestIdleCallback(function () {
                try {
                    performanceTracking.mark('write-session-storage-start');
                    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(next));
                    performanceTracking.mark('write-session-storage-end');
                    performanceTracking.measure('write-session-storage', 'write-session-storage-start', 'write-session-storage-end');
                }
                catch (e) {
                    // ignore the errors, e.g. quota is full or security error
                    console.error(e);
                }
                pendingWrite = false;
            });
        }
        return next;
    }; };
}
